module.exports = __webpack_public_path__ + "img/52business.1e60875d.png";